import React, { useEffect, useState } from "react";
import { Card, Divider, Button, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import debounce from "lodash/debounce";
import NumberInput from "../input/number-input";
import FixedSelectInput from "../input/fixed-select-input";
import SearchableSelectInput from "../input/searchable-select-input";
import NumberUnitInput from "../input/number-unit-input";

const ToyCard = ({ toy, onUpdate, onDelete, onSendEvent }) => {
  const fieldMap = {
    FIXED_SELECT: f => (
      <FixedSelectInput
        useBiToggle={true}
        valueSpec={f}
        onChange={value => handleFieldChange(f, value)}
        onError={() => {}}
      ></FixedSelectInput>
    ),
    DYNAMIC_SELECT: f => (
      <SearchableSelectInput
        field={f}
        onChange={value => handleFieldChange(f, value)}
      ></SearchableSelectInput>
    ),
    NUMBER: f => (
      <NumberInput
        valueSpec={f}
        onChange={value => handleFieldChange(f, value)}
      ></NumberInput>
    ),
    NUMBER_UNIT: f => (
      <NumberUnitInput
        valueSpec={f}
        onChange={(value, unit, max, min) =>
          handleFieldChange(f, value, unit, max, min)
        }
      ></NumberUnitInput>
    ),
    BUTTON: (f, func) => (
      <Button type="primary" onClick={() => handleFieldClick(func)}>
        {f.name}
      </Button>
    ),
  };

  const [toyData, setToyData] = useState(toy);

  useEffect(() => {
    setToyData(toy);
    return () => {};
  }, [toy]);

  const handleFieldClick = func => {
    onSendEvent(toy.name, func.function);
  };

  const handleFieldChange = (
    field,
    newValue,
    unit = null,
    max = null,
    min = null,
  ) => {
    field.value = newValue;
    if (unit) {
      field.unit = unit;
    }
    if (max != null) {
      field.max = max;
    }
    if (min != null) {
      field.min = min;
    }
    debouncedUpdate(JSON.parse(JSON.stringify(toyData)));
  };

  const debouncedUpdate = debounce(updatedToy => {
    update(updatedToy);
  }, 500);

  const update = updatedToy => {
    onUpdate(updatedToy);
  };

  const handleDelete = () => {
    onDelete(toyData.name);
  };

  return (
    <Card
      title={toyData?.name}
      extra={
        <Button
          type="text"
          icon={<DeleteOutlined />}
          onClick={handleDelete}
          aria-label="delete"
        />
      }
    >
      {toyData ? (
        <Space direction="vertical" size="small" style={{ width: "100%" }}>
          {toyData.functions.map((func, i1) =>
            func.fields.map((field, i2) => (
              <div key={`${i1}.${i2}`} style={{ marginBottom: 8, marginTop: 8 }}>
                {fieldMap[field.ui](field, func)}
              </div>
            )),
          )}
        </Space>
      ) : (
        <></>
      )}
    </Card>
  );
};

export default ToyCard;
